import { SettingsPageContent } from "./SettingsPageContent/SettingsPageContent";
import { SettingsPageFooter } from "./SettingsPageFooter/SettingsPageFooter";

export const Content = SettingsPageContent;
export const Footer = SettingsPageFooter;
